// Builds product tabs out of the headings in the product description. The row keeps
// the accordion appearance, but opens its content in a slideout panel, matching the
// tabs rendered by snippets/product-tab.liquid

function tabId(heading, index) {
  var slug = heading.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return 'product-tab-desc-' + index + (slug ? '-' + slug : '');
}

function createTab(heading, id) {
  const tab = document.createElement('div');
  tab.className = 'accordion';
  tab.innerHTML =
    '<button type="button" class="accordion__toggle h6" aria-controls="' + id + '" aria-expanded="false" aria-haspopup="dialog">' +
      '<span class="text-with-icon gap-4"></span>' +
      '<span class="animated-plus" aria-hidden="true"></span>' +
    '</button>' +
    '<x-drawer id="' + id + '" class="slideout drawer color-scheme color-scheme--dialog slideout--lg" open-from="right">' +
      '<span class="h5" slot="header"></span>' +
      '<div class="prose"><div class="Rte"></div></div>' +
    '</x-drawer>';

  tab.querySelectorAll('.text-with-icon, [slot="header"]').forEach(function (el) {
    el.textContent = heading;
  });

  return tab;
}

function productDescTabs() {
  const tabsContainer = document.querySelector('.Product__Tabs');
  if (!tabsContainer) {
    return;
  }

  // Headings are collected across every description block first, so the index used for
  // the tab id keeps counting across them — matching how jQuery's .find().each() numbered
  // a combined set.
  const headings = [];
  document.querySelectorAll("[data-block-type='description']").forEach(function (desc) {
    desc.querySelectorAll('h2, h3, h4, h5, h6').forEach(function (heading) {
      headings.push(heading);
    });
  });

  const tabs = [];

  headings.forEach(function (headingEl, index) {
    const list = headingEl.nextElementSibling;
    if (!list || !list.matches('ul, p')) {
      return;
    }
    const heading = headingEl.textContent;
    const tab = createTab(heading, tabId(heading, index));
    // appendChild moves the existing node rather than copying it, as jQuery's .append() did.
    tab.querySelector('.Rte').appendChild(list);
    headingEl.remove();
    tabs.push(tab);
  });

  // Prepending in reverse leaves the tabs in source order at the top of the container.
  tabs.reverse().forEach(function (tab) {
    tabsContainer.prepend(tab);
  });
}

// events
if (window.theme && window.theme.pageType === 'product') {
  productDescTabs();
}
